<template>
  <Slide anchor="contacts" title="Контакты" linkable>
    <ContactsLink
      v-for="(contact, type) in contacts"
      :key="type"
      :contact="contact"
      :type="type"
    />
  </Slide>
</template>

<script>
  import Slide from './Slide';
  import ContactsLink from './ContactsLink';

  export default {
    name: 'Contacts',
    components: { ContactsLink, Slide },

    data() {
      return {
        contacts: {
          /*vk: {
            displayType: 'VK',
            url: '#',
            displayName: 'vk.me/flex-studio',
          },*/
          telegram: {
            displayType: 'Telegram',
            url: 'tg://resolve?domain=zotovmaxim',
            displayName: '@zotovmaxim',
          },
          email: {
            displayType: 'E-mail',
            url: 'mailto:sales@flex-stud.io',
            displayName: 'sales@flex-stud.io',
          },
          phone: {
            displayType: 'Телефон',
            url: 'tel:+79152003444',
            displayName: '+7 (915) 200–34–44',
          },
        },
      };
    },
  };
</script>

<style lang="less" scoped>
  //
</style>

<style lang="less">
  #contacts {
    .content {
      flex-direction: column;
    }
  }
</style>
